import { wrapperStyleType } from 'shared-types/index';
import {IWidgetTheme} from 'shared-types/MUI4ThemeTypes';

export interface ICoverInput {
  wrapperStyle: wrapperStyleType;
  theme: IWidgetTheme;
  coversPrefill?: number;
  maxPeoplePerBooking: number;
  minPeoplePerBooking: number;
  variant: coverInputVariant;
  omitMaxReachedMsg?: boolean;
  disableControls?: boolean;
  hasDelay: boolean;
  allowMaxBreach: boolean;
  minPaxPerBookingMessage?: string;
  getMaxBreachMessage?: (maxPeoplePerBooking: number) => string;
  handleChange: (coversCount: number, isShowingMessage: boolean) => void;
  handlePendingChange?: () => void;
}

export enum coverInputVariant {
  large = 'large',
  small = 'small',
  smallDesignV2 = 'smallDesignV2',
}

export const classPrefix = 'CoverInput';
